<template>
  <Drawer
    ref="modal"
    v-model="showModal"
    width="85%"
    :title="modalTitle"
    :closable="false"
    :mask-closable="false"
    class="drawer"
  >
    <div id="mapmap" class="drawer-map">
      <!-- <Icon type="md-pin" class="positon-icon" size="40" color="#6149f1"></Icon> -->
    </div>
    <div id="panel">
      <p style="margin-bottom:8px">输入关键字，将展示相关地点提示，点击提示可定位到该处。</p>
      <Input v-model="placeKeyName" search enter-button="搜索" placeholder="输入关键字" @on-search="getKeywordList" @on-enter="getKeywordList"></Input>
      <div v-show="showListBlock" class="suggest-box">
        <div v-for="item in suggestionList" :key="item.id" class="suggest-item" :class="item.id === selectId?'suggest-item-active':''" @click="handleGetSelectItem(item)">
          <span>{{ item.title }}</span><span>{{ item.address }}</span>
        </div>
      </div>
    </div>
    <div class="drawer-bottom">
      <div v-if="locationInfo" class="map-info">
        当前地址：{{ locationInfo.address }}
      </div>
      <div v-if="locationInfo" class="map-info">
        当前定位：纬度：{{ locationInfo.lat }}；经度：{{ locationInfo.lng }}
      </div>
      <div class="drawer-btn">
        <Button @click="handleCancle">取消</Button>
        <Button type="primary" @click="handleSureLocation">确定当前定位</Button>
      </div>

    </div>
  </Drawer>
</template>
<script>
import axios from 'axios';
import { loadMP, jsonpRequest } from '@/utils/location.js';
export default {
  props: {
    modalTitle: {
      type: String,
      default: '地图定位'
    }
  },
  data() {
    return {
      showModal: false, // 弹窗
      map: null,
      TMap: null,
      placeKeyName: '',
      suggest: null, // 关键词建议实例
      suggestionList: [], // 建议列表
      markers: null,
      selectId: '',
      infoWindow: null,
      showListBlock: false,
      geocoder: null,
      locationInfo: null
    };
  },
  methods: {
    initMap(location, ad_info, locationInfo) {
      this.$nextTick(() => {
        loadMP('mapmap', location).then(({ map, TMap, geocoder, markers }) => {
          this.map = map;
          this.TMap = TMap;
          this.suggest = new this.TMap.service.Suggestion({
            // 新建一个关键字输入提示类
            pageSize: 20, // 返回结果每页条目数
            region: ad_info.city, // 限制城市范围
            regionFix: false // 搜索无结果时是否固定在当前城市
          });
          this.geocoder = geocoder;
          this.markers = markers;
          if (locationInfo) {
            this.updateLocationToMap(locationInfo);
          } else {
            this.getMapCenterInfo();
          }
        });
      });
    },
    updateLocationToMap(locationInfo) {
      const { lat, lng, address } = locationInfo;
      this.map.setCenter(new this.TMap.LatLng(lat, lng));
      this.markers.setGeometries([{
        id: 1, // 点标注数据数组
        position: new this.TMap.LatLng(lat, lng)
      }]);
      this.locationInfo = {
        lat,
        lng,
        address,
        title: address
      };
    },
    getMapCenterInfo() {
      const { lat, lng, ...other } = this.map.getCenter();
      console.log(lat, lng, '经纬度');
      this.geocoder
        .getAddress({ location: new this.TMap.LatLng(lat, lng), getPoi: true, poiOptions: 'radius=500' }) // 将给定的坐标位置转换为地址
        .then((result) => {
          this.markers.setGeometries([{
            id: 1, // 点标注数据数组
            position: new this.TMap.LatLng(lat, lng)
          }]);
          this.locationInfo = {
            lat,
            lng,
            address: result.result.address
          };
          // 显示搜索到的地址
        });
    },
    async openDrawer(locationInfo) {
      this.showModal = true;
      if (this.map && locationInfo) {
        this.updateLocationToMap(locationInfo);
        return;
      } else if (this.map) {
        const { location, ad_info } = await this.getIpLocation();
        this.map.setCenter(new this.TMap.LatLng(location.lat, location.lng));
        this.getMapCenterInfo();
        return;
      }
      const { location, ad_info } = await this.getIpLocation();
      this.initMap(location, ad_info, locationInfo);
    },
    async getIpLocation() {
      const res = await jsonpRequest('https://apis.map.qq.com/ws/location/v1/ip?callback=jsonCallBack&key=INTBZ-D35KD-6E44X-P3UMA-BWQGF-QOBOZ&output=jsonp');
      console.log(res, '=====');
      if (res.status === 0) {
        return res.result;
      } else {
        return null;
      }
    },

    handleCancle() {
      this.showModal = false;
    },
    handleSureLocation() {
      this.$emit('getLocation', this.locationInfo);
      this.showModal = false;
    },
    // 获取搜索关键词建议列表
    getKeywordList() {
      if (!this.placeKeyName) {
        return;
      }
      this.suggest
        .getSuggestions({ keyword: this.placeKeyName, location: this.map.getCenter() })
        .then((result) => {
        // 以当前所输入关键字获取输入提示
          console.log(result);
          if (result.status === 0) {
            this.suggestionList = result.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.showListBlock = true;
    },
    // 获取选中的
    handleGetSelectItem(item) {
      this.placeKeyName = item.title;
      this.map.setCenter(new this.TMap.LatLng(item.location.lat, item.location.lng));
      this.markers.setGeometries([{
        id: 1, // 点标注数据数组
        position: new this.TMap.LatLng(item.location.lat, item.location.lng)
      }]);
      this.locationInfo = {
        lat: item.location.lat,
        lng: item.location.lng,
        address: `${item.address}`,
        title: item.title
      };
      this.selectId = item.id;
      this.showListBlock = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.drawer-map{
  width: 100%;
  height: 85%;
  position: relative;
  .positon-icon{
    position: absolute;
    top: 50%;
    transform: translate(-50%,-50%);
    left: 50%;
  }
}
#panel {
  position: absolute;
  background: #FFF;
  width:350px;
  padding: 20px;
  z-index: 9999;
  top: 30px;
  left: 30px;
}
.drawer-bottom{
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 15%;
  box-sizing: border-box;
  padding: 24px;
  z-index: 9999;
  background: #fff;
  .map-info{
    margin-bottom: 16px;
    font-weight: bold;
  }
  .drawer-btn{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  button+button{
    margin-left: 16px;
  }
}
.suggest-box{
  margin-top: 8px;
  max-height: 400px;
  overflow-y: scroll;
  .suggest-item{
    padding: 8px 16px;
    cursor: pointer;
    span:nth-of-type(1){
      font-weight: bold;
      font-size: 16px;
      margin-right: 16px;
    }
  }
  .suggest-item:hover{
    color: #6149f1;
  }
  .suggest-item-active{
    color: #6149f1;
  }
}
.drawer{
  /deep/.ivu-drawer-wrap{
    z-index: 100000!important;
  }
  /deep/.ivu-drawer-mask{
    z-index: 100000!important;
  }
}
</style>
